// «See all» under a product slider or grid: shows every product in place,
// then hides the button. In a slider it switches the slider to a plain
// grid (pslider.js); in an old-style grid it reveals the cards that were
// rendered hidden. One delegated listener serves every section.
(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-grid-more]');
    if (!btn) return;
    var grid = document.getElementById(btn.getAttribute('aria-controls'));
    if (!grid) return;

    var cards = grid.querySelectorAll('.pcard[hidden]');
    for (var i = 0; i < cards.length; i++) cards[i].hidden = false;

    var slider = grid.closest('[data-pslider]');
    if (slider) {
      slider.classList.add('is-grid');
      slider.dispatchEvent(new CustomEvent('pslider:grid'));
    }

    btn.setAttribute('aria-expanded', 'true');
    var wrap = btn.closest('.grid-more-cta');
    if (wrap) wrap.hidden = true;

    // The button is gone, so keep keyboard focus inside the products
    // instead of dropping it on the page body.
    var target = cards.length ? cards[0].querySelector('a') : grid.querySelector('.pcard a');
    if (target) target.focus({ preventScroll: true });
  });
})();
